require("!!C:\\ixs\\Source\\ng_2.0\\edu-ng\\node_modules\\script-loader\\addScript.js")(require("!!C:\\ixs\\Source\\ng_2.0\\edu-ng\\node_modules\\raw-loader\\index.js!C:\\ixs\\Source\\ng_2.0\\edu-ng\\node_modules\\moment\\moment.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/moment/moment.js
// module id = 754
// module chunks = 322